import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-profit-loss-report',
  templateUrl: './profit-loss-report.component.html',
  styleUrls: ['./profit-loss-report.component.css']
})
export class ProfitLossReportComponent implements OnInit {
  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 
  PaymentModelSearch = {
    AccID: 0,
    FromDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    ToDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    Print:"",
    ReportType:1,
};

PrintProfitLossReport  () {
  this.PaymentModelSearch.FromDate= this.PaymentModelSearch.FromDate!=null && this.PaymentModelSearch.FromDate!=''?moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
  this.PaymentModelSearch.ToDate=this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
 
    var url = "profitlossreportprint?PrintType=ProfitLossReport&FromDate=" +this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate + "&AccID=" + this.PaymentModelSearch.AccID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
};
SearchBankAccName = '';
ClearSearch  () {
    this.PaymentModelSearch.AccID = 0;
    this.PaymentModelSearch.ReportType = 1;
    this.PaymentModelSearch.FromDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.PaymentModelSearch.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.SearchBankAccName = '';
};
loadingSearch = false;
AccountList:any;
FinalTotal = 0;
IncomeTotal =0;
ExpensesTotal = 0;
GetProfitLossReport  () {

    this.loadingSearch = true;
    this.spinnerService.show();
    this.PaymentModelSearch.FromDate= this.PaymentModelSearch.FromDate!=null && this.PaymentModelSearch.FromDate!=''?moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
    this.PaymentModelSearch.ToDate=this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
    this.accService.GetProfitLossReport(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
        this.AccountList = response.AccountList;
        this.FinalTotal = 0;
               
if(this.AccountList!=null && this.AccountList.length>0){
        this.IncomeTotal=this.AccountList[0].total;
        this.ExpensesTotal = this.AccountList[1].total;
        this.FinalTotal = this.IncomeTotal + this.ExpensesTotal;
}

        setTimeout( ()=>{
          this.spinnerService.hide();
            this.loadingSearch = false;
            this.globalHelper.CheckActionStatus(response);
        }, 10);
    });
};
FilePath:any;
GetProfitLossReportDownload  () {
    this.PaymentModelSearch.Print = 'XLS';
    this.loadingSearch = true;
   this.spinnerService.show()
    this.PaymentModelSearch.FromDate= this.PaymentModelSearch.FromDate!=null && this.PaymentModelSearch.FromDate!=''?moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY'):'';
    this.PaymentModelSearch.ToDate=this.PaymentModelSearch.ToDate!=null && this.PaymentModelSearch.ToDate!=''?moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY'):'';
    this.accService.GetProfitLossReport(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
        // this.AccountList = response.AccountList;
        this.FilePath = response.FilePath;
        window.location = response.FilePath;
        setTimeout( () =>{
          
            this.loadingSearch = false;
            this.spinnerService.hide()
           this.globalHelper. CheckActionStatus(response);

            this.PaymentModelSearch.Print = '';
        }, 10);
    });
};




  ngOnInit() {
    setTimeout(() => {

      this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");

      this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");
      this.GetProfitLossReport();
    }, 200);
    
  }

}
